define.alias("ember-cli-string-helpers/helpers/lowercase", "preview-grid/helpers/lowercase");